import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _PinLightLeft(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "M13.636 4.91c.653-.436.98-.654 1.335-.618.356.035.633.312 1.188.867l2.682 2.682c.555.555.832.832.867 1.188s-.182.682-.617 1.335l-1.65 2.473c-.561.843-.842 1.264-1.066 1.714a8 8 0 0 0-.427 1.031c-.16.477-.26.974-.458 1.967l-.19.955-.002.006a1 1 0 0 1-1.547.625l-.005-.004-.027-.018a35 35 0 0 1-8.832-8.832c-.005-.007-.01-.013-.018-.027l-.004-.005a1 1 0 0 1 .625-1.547l.006-.001.955-.191c.993-.199 1.49-.298 1.967-.458a8 8 0 0 0 1.03-.427c.45-.224.872-.505 1.715-1.067z" }),
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M4.414 19.586 8.5 15.5" })));
}
const PinLightLeft = forwardRef(_PinLightLeft);
export { PinLightLeft };
